module.exports = __webpack_public_path__ + "media/v2/components/HomePage/shared/PrizeSlider/img/secondary_3-6ed612d5efab4900e403b1ce15a722b3.png";